import {
  defaultMinesRoundListFilter,
  minesRoundListColumnVisibilityOptions,
  defaultMinesRoundListColumnVisibility,
} from '@utils/tables/rounds/minesRoundListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  limit: 25,
  page: 1,
  total: 0,
  selectedFilters: defaultMinesRoundListFilter,
  columnVisibility: defaultMinesRoundListColumnVisibility,
  columnVisibilityOptions: minesRoundListColumnVisibilityOptions,
  roundTableFilters: {},
  showRoundStatusModalDialog: false,
  currentRoundConfig: {},
};

const minesRoundTableSlice = createSlice({
  name: 'minesRoundTable',
  initialState,
  reducers: {
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setRoundTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { roundTableFilters } = state;

      const newRoundTableFilters = { ...roundTableFilters, [codeName]: value };
      state.roundTableFilters = newRoundTableFilters;
    },
    setClearRoundTableFilters: (state) => {
      state.roundTableFilters = {};
    },
    setShowRoundStatusModalDialog: (state, { payload }) => {
      state.showRoundStatusModalDialog = payload;
    },
    setCurrentRoundConfig: (state, { payload }) => {
      state.currentRoundConfig = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: minesRoundTableReducer } = minesRoundTableSlice;
export const {
  setColumnVisibility,
  setLimit,
  setTotal,
  setPage,
  setRoundTableFilters,
  setCurrentRoundConfig,
  setClearRoundTableFilters,
  setShowRoundStatusModalDialog,
} = minesRoundTableSlice.actions;
